import { extractErrorMessage } from "utils/extractErrorMessage";

import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";
import type {
  LeaveTypesApiT,
  LeaveTypesMapperT,
} from "../types/leaveTypes.types";

type LeaveTypesRepositoryParamsT = {
  leaveTypesApi: LeaveTypesApiT;
  leaveTypesMapper: LeaveTypesMapperT;
};

export const createLeaveTypesRepository = ({
  leaveTypesApi,
  leaveTypesMapper,
}: LeaveTypesRepositoryParamsT): LeaveTypesRepositoryT => ({
  getAll: async (colaboraInstanceId, category = "PERMISSION") => {
    try {
      const response = await leaveTypesApi.getAll(colaboraInstanceId, category);

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al obtener los tipos de permiso");
      }

      return leaveTypesMapper.leaveTypesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los tipos de permiso",
      );

      throw new Error(message);
    }
  },
  create: async (data, colaboraInstanceId) => {
    try {
      const dto = leaveTypesMapper.toCreateDTO(data);

      const response = await leaveTypesApi.create(dto, colaboraInstanceId);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Ocurrió un error al crear el tipo de permiso");
      }

      return leaveTypesMapper.createDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al crear el tipo de permiso",
      );

      throw new Error(message);
    }
  },
  update: async (data, colaboraInstanceId, category) => {
    try {
      const dto = leaveTypesMapper.toDTO(data);

      const response = await leaveTypesApi.update(
        dto,
        colaboraInstanceId,
        category,
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Ocurrió un error al actualizar el tipo de ausencia");
      }

      return leaveTypesMapper.updateDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al actualizar el tipo de ausencia",
      );

      throw new Error(message);
    }
  },
  delete: async (typeIds, colaboraInstanceId) => {
    try {
      const dto = leaveTypesMapper.toDeleteDTO(typeIds);

      const response = await leaveTypesApi.delete(dto, colaboraInstanceId);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Ocurrió un error al eliminar el tipo de permiso");
      }

      return leaveTypesMapper.deleteDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al eliminar el tipo de permiso",
      );

      throw new Error(message);
    }
  },
  toggleActiveStatus: async (typeId, isActive, colaboraInstanceId) => {
    try {
      const dto = leaveTypesMapper.toToggleActiveStatusDTO(isActive);

      const response = await leaveTypesApi.toggleActiveStatus(
        typeId,
        dto,
        colaboraInstanceId,
      );

      if (response.status !== 200) {
        throw new Error(
          "Ocurrió un error al actualizar el estado del tipo de permiso",
        );
      }
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al actualizar el estado del tipo de permiso",
      );

      throw new Error(message);
    }
  },
});
